export default "__VITE_ASSET__APoVQjvq__"